import { forgetSharedDevice } from "../../../security/shared-device.mjs";
import store from "../../index.js";
import api from "../../../utils/api.js";
import userConstant from "../../../mixins/user/const/userConstant.js";
import userAcConstant from "../../../mixins/user/const/userAcConstant.js";

export const modules = {
  store,
};

export const state = {
  _error: { code: 0, message: "" },
  _mfa: {
    qrCodeUrl: null,
    isMfa: false,
  },
};

export const mutations = {
  [userConstant.ADD_USER_MFA]: (state, item) => {
    console.log("ㅁㄴㄻㄴㄻㄴㄻㄴㄹㄴㅁㄹ", item);
    state._mfa.isMfa = item;
  },
  [userConstant.ADD_USER_QRCODE]: (state, item) => {
    state._mfa.qrCodeUrl = item;
  },
  [userConstant.ADD_USER_OTP]: (state, item) => {
    state._mfa.qrCodeUrl = item;
  },
  [userConstant.ADD_USER_LOGIN_ERROR]: (state, item) => {
    state._error = { code: 0, message: "" };
    state._error = item;
  },
};

export const actions = {
  async acManagerLogin({ commit }, params) {
    const url = userAcConstant.POST_USER_LOGIN;
    try {
      const res = await api.post(url, params);
      if (res?.data?.code === 0) {
        commit(userConstant.ADD_USER_MFA, res.data.data.isMfa);
        return true;
      } else {
        commit(userConstant.ADD_USER_LOGIN_ERROR, res.data);
        return false;
      }
    } catch (err) {
      localStorage.clear();
      commit(userConstant.ADD_USER_LOGIN_ERROR, err.data);
      return false;
    }
  },
  async acGetManagerQrcode({ commit }, params) {
    const url = userAcConstant.POST_USER_QRCODE;
    try {
      const res = await api.post(url, params);
      if (res?.data?.code === 0) {
        commit(userConstant.ADD_USER_QRCODE, res.data.data.qrcode);
        return true;
      } else {
        commit(userConstant.ADD_USER_LOGIN_ERROR, res.data);
        return false;
      }
    } catch (err) {
      commit(userConstant.ADD_USER_LOGIN_ERROR, err.data);
      return false;
    }
  },
  async acVerifyOtp({ commit }, params) {
    const url = userAcConstant.POST_USER_OTP;
    try {
      const res = await api.post(url, params);
      if (res?.data?.code === 0) {
        // PIKA_ONLY 권한 = pika-console 전용 계정. 기존 admin 화면 진입 차단.
        // (manager.grant 컬럼 그대로 BE 응답에 노출 — api-admin NZSC-2965)
        if (res.data.data.grant === "PIKA_ONLY") {
          localStorage.clear();
          commit(userConstant.ADD_USER_LOGIN_ERROR, {
            code: 403,
            message: "이 계정은 pika-console 전용입니다. https://pika.naezipscan.com 으로 접속해주세요.",
          });
          return false;
        }
        void forgetSharedDevice().catch(() => {});
        localStorage.ad_to_ac_se = res.data.data.session;
        localStorage.name = res.data.data.name;
        return true;
      } else {
        commit(userConstant.ADD_USER_LOGIN_ERROR, res.data);
        return false;
      }
    } catch (err) {
      commit(userConstant.ADD_USER_LOGIN_ERROR, err.data);
      return false;
    }
  },
};

export const getters = {
  geCodeFail: state => {
    return state._error.message;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
